import { useEffect, useState } from 'react';
import useSWR from 'swr';
import useSdk from 'helpers/hooks/useSdk';
import { revalidateOptions } from 'frontastic';

type Params = { email?: string; order?: string };

const usePublicOrder = (params: Params) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: define Order type for public view
  const [order, setOrder] = useState<any>(null); // TODO: type
  const [loading, setLoading] = useState<boolean>(!!(params.email && params.order));
  const [loaded, setLoaded] = useState<boolean>(false); // true only after a fetch attempt completes
  const sdk = useSdk();

  const shippingMethodsResults = useSWR(
    '/action/cart/getShippingMethods',
    sdk.composableCommerce.cart.getShippingMethods,
    revalidateOptions,
  );
  const shippingMethods = shippingMethodsResults.data?.isError ? {} : { data: shippingMethodsResults.data?.data };

  useEffect(() => {
    if (!params.email || !params.order) {
      setOrder(null);
      setLoading(false);
      setLoaded(false);
      return;
    }
    setLoading(true);
    setLoaded(false);
    sdk
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: type SDK response
      .callAction<any>({
        // TODO: type
        actionName: 'yggdrasil/getPublicOrder',
        payload: { email: params.email, orderId: params.order },
      })
      .then(
        (res) => {
          setOrder(res.isError ? null : res.data.order);
          setLoading(false);
          setLoaded(true);
        },
        () => {
          setOrder(null);
          setLoading(false);
          setLoaded(true);
        },
      );
  }, [params.email, params.order, sdk]);
  return {
    order,
    shippingMethods,
    loading,
    loaded,
  };
};

export default usePublicOrder;
